<template>
    <el-form :model="resetPwdForm" ref="resetPwdForm"
             class="resetPwdForm md-layout md-alignment-center-center">
        <md-card class="md-layout-item">
            <md-card-header>
                <div class="md-title">Password Reset</div>
            </md-card-header>

            <div v-if="!password_reset">
                <md-card-content>
                    <div class="md-layout-item">
                        Please enter your new password.
                    </div>
                    <div class="md-layout md-gutter">
                        <md-field id="password1" :class="getValidationClass('password1')">
                            <label for="password1">Password</label>
                            <md-input v-model="resetPwdForm.password1"
                                      required
                                      name="password1"
                                      type="password"
                                      @keyup.enter="ResetPassword()"></md-input>
                            <span class="md-error"
                                  v-if="!$v.resetPwdForm.password1.required">This field is required</span>
                        </md-field>
                        <md-field id="password2" :class="getValidationClass('password2')">
                            <label for="password2">Confirm password</label>
                            <md-input v-model="resetPwdForm.password2"
                                      required
                                      name="password2"
                                      type="password"
                                      @keyup.enter="ResetPassword()"></md-input>
                            <span class="md-error"
                                  v-if="!$v.resetPwdForm.password2.required">This field is required</span>
                            <span class="md-error" v-else-if="!$v.resetPwdForm.password2.sameAsPassword">The passwords are not identical</span>
                        </md-field>
                    </div>
                    <md-card-actions style="padding: 24px 16px 16px;">
                        <el-button class="md-primary md-raised md-layout-item md-alignment-center-center"
                                   @click="ResetPassword()"
                                   :loading="resetting_password"
                                   type="primary"
                        >Reset password
                        </el-button>
                    </md-card-actions>
                </md-card-content>
            </div>

            <md-card-content v-if="password_reset">
                <pre>Your password is successfully reset.
Go back to log in:
                </pre>
                <el-button class="md-primary md-raised md-layout-item md-alignment-center-center"
                           @click="LogIn()"
                           type="primary"
                >Back to log in
                </el-button>
            </md-card-content>

        </md-card>
    </el-form>
</template>

<script>
    import {mapState} from "vuex";
    import {validationMixin} from 'vuelidate';
    import {required, sameAs} from 'vuelidate/lib/validators';

    export default {
        name: "ResetPasswordView",
        mixins: [validationMixin],
        data() {
            return {
                resetPwdForm: {
                    password1: '',
                    password2: '',
                }
            }
        },
        validations: {
            resetPwdForm: {
                password1: {
                    required
                },
                password2: {
                    required,
                    sameAsPassword: sameAs('password1')
                }
            }
        },
        watch: {
            show_notification: function (newVal) {
                if (newVal === true) {
                    this.$notify({
                        title: this.notification['type'].charAt(0).toUpperCase() + this.notification['type'].slice(1),
                        message: this.notification['text'],
                        type: this.notification['type'],
                        position: 'top-right',
                    });
                }
            }
        },
        computed: {
            ...mapState({
                notification: state => state.auth.notification,
                show_notification: state => state.auth.show_notification,
                resetting_password: state => state.auth.resetting_password,
                password_reset: state => state.auth.password_reset
            }),
        },
        methods: {
            ResetPassword: function () {
                this.$v.$touch()
                if (this.$v.$invalid) return
                let payload = {
                    'password': this.resetPwdForm.password1,
                    'token': this.$route.query.token
                }
                this.$store.dispatch('auth/resetPassword', payload)
            },
            getValidationClass(fieldName) {
                const field = this.$v.resetPwdForm[fieldName]

                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty
                    }
                }
            },
            LogIn: function () {
                this.$router.push('/login');
            }
        }
    }

</script>

<style scoped>
    form {
        display: inline-block;
        float: none;
        height: 200px;
        position: relative;
        top: 50%;
        -ms-transform: translateY(50%);
        transform: translateY(50%);
    }

    div.md-layout {
        padding-left: 30px;
        padding-right: 30px;
    }
</style>